if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
            price: ".m-sticky-addtocart--price"
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");
        if (!hasQueryString && this.selectedVariantDefault && this.variantData && this.variantData.length > 1)
          this.disableSelectedVariantDefault();

        this.init();
        this.setStickyAddToCartHeight();

        this.addEventListener("change", () => {
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          this.updateButton(true, "", false);
          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          }
        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }
        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        if (buyNowBtn) this.enable_dynamic_checkout = true;
        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
        this.observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.boundingClientRect.top < 150) {
        // form is above the viewport → show sticky ATC
        this.container.style.setProperty("--m-translate-y", 0);
        document.documentElement.classList.add("stick-atc-show");
      } else {
        // form is visible or below → hide sticky ATC
        this.container.style.setProperty("--m-translate-y", "100%");
        document.documentElement.classList.remove("stick-atc-show");
      }
    });
  },
  { threshold: 0 }
);
        }

        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          hasCustomFieldRequired &&
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();
          const stickyAddBtn = this.querySelector('.sticky-atc-form [name="add"]');
  if (stickyAddBtn && typeof gtag === "function") {
    stickyAddBtn.addEventListener("click", () => {
      if (!this.currentVariant && !this.unitPrice) return;

     const qty = Math.max(1, parseInt(
  this.querySelector('[name="quantity"]')?.value || 1, 10
));

      gtag("event", "add_to_cart", {
        currency: window.Shopify?.currency?.active || "USD",
        value: (this.unitPrice / 100) * qty,
        items: [{
          item_id: this.currentVariant?.sku || String(this.productId),
          item_name: document.querySelector(this.selectors.prodTitle)?.textContent?.trim(),
          item_variant: this.currentVariant?.title,
          price: this.unitPrice / 100,
          quantity: qty,
        }]
      });
    });
  }
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerSelects) return;
        pickerSelects.value = "";
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text');

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          addButtonText.textContent = window.MinimogStrings.addToCart;
        }
      }

syncWithMainProductForm() {
  const variantInput = this.querySelector('[name="id"]');
  const stickyPrice = this.querySelector(this.selectors.price);
  const mainPrice = document.querySelector(".m-price");
const mainQtyInput = this.querySelector('[name="quantity"]');

  const formatMoney = (cents) => {
    const format = window.MinimogSettings?.money_format || "${{amount}}";
    const amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  };

  const getQty = () => Math.max(1, parseInt(mainQtyInput?.value || 1, 10));

  const updateStickyPrice = () => {
    if (!stickyPrice || !mainPrice) return;
    stickyPrice.innerHTML = mainPrice.innerHTML;

    if (this.unitPrice != null) {
      const total = this.unitPrice * getQty();
      const formatted = formatMoney(total);
      // Update both regular and sale price spans, skip the strikethrough compare-at
      stickyPrice.querySelectorAll(".m-price-item--regular:not(s), .m-price-item--sale").forEach((el) => {
        el.textContent = formatted;
      });
    }
  };

  window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (variant) => {
    variantInput.value = variant ? variant.id : variantInput.value;
    this.unitPrice = variant ? variant.price : null;
    updateStickyPrice();
  });
if (mainQtyInput) {
  // Intercept .value property assignments from the stepper custom element
  let _qtyValue = mainQtyInput.value;
  Object.defineProperty(mainQtyInput, "value", {
    get() { return _qtyValue; },
    set(newVal) {
      _qtyValue = newVal;
      updateStickyPrice();
    },
    configurable: true
  });

  // Still catch keyboard input
  mainQtyInput.addEventListener("change", updateStickyPrice);
  mainQtyInput.addEventListener("input", updateStickyPrice);
}
  const defaultVariant = this.variantData?.find((v) => v.id === Number(variantInput?.value));
  if (defaultVariant) this.unitPrice = defaultVariant.price;

  updateStickyPrice();
}


      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
